function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import React, { Component, Children, cloneElement } from 'react';
import { Animated, TouchableHighlight, View } from 'react-native';
import LightboxOverlay from "./LightboxOverlay";

class Lightbox extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      isOpen: false,
      origin: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      layoutOpacity: new Animated.Value(1)
    });

    _defineProperty(this, "getContent", () => {
      if (this.props.renderContent) {
        return this.props.renderContent();
      }

      if (this.props.activeProps) {
        return /*#__PURE__*/cloneElement(Children.only(this.props.children), this.props.activeProps);
      }

      return this.props.children;
    });

    _defineProperty(this, "getOverlayProps", () => ({
      isOpen: this.state.isOpen,
      origin: this.state.origin,
      renderHeader: this.props.renderHeader,
      swipeToDismiss: this.props.swipeToDismiss,
      springConfig: this.props.springConfig,
      backgroundColor: this.props.backgroundColor,
      children: this.getContent(),
      didOpen: this.props.didOpen,
      willClose: this.props.willClose,
      onClose: this.onClose
    }));

    _defineProperty(this, "open", () => {
      this._root.measure((ox, oy, width, height, px, py) => {
        this.props.onOpen();
        this.setState({
          isOpen: !!this.props.navigator,
          isAnimating: true,
          origin: {
            width,
            height,
            x: px,
            y: py
          }
        }, () => {
          this.props.didOpen();

          if (this.props.navigator) {
            const route = {
              component: LightboxOverlay,
              passProps: this.getOverlayProps()
            };
            const routes = this.props.navigator.getCurrentRoutes();
            routes.push(route);
            this.props.navigator.immediatelyResetRouteStack(routes);
          } else {
            this.setState({
              isOpen: true
            });
          }

          setTimeout(() => {
            this._root && this.state.layoutOpacity.setValue(0);
          });
        });
      });
    });

    _defineProperty(this, "close", () => {
      throw new Error('Lightbox.close method is deprecated. Use renderHeader(close) prop instead.');
    });

    _defineProperty(this, "onClose", () => {
      this.state.layoutOpacity.setValue(1);
      this.setState({
        isOpen: false
      }, this.props.onClose);

      if (this.props.navigator) {
        const routes = this.props.navigator.getCurrentRoutes();
        routes.pop();
        this.props.navigator.immediatelyResetRouteStack(routes);
      }
    });
  }

  render() {
    // measure will not return anything useful if we dont attach a onLayout handler on android
    return /*#__PURE__*/React.createElement(View, {
      ref: component => this._root = component,
      style: this.props.style,
      onLayout: () => {}
    }, /*#__PURE__*/React.createElement(Animated.View, {
      style: {
        opacity: this.state.layoutOpacity
      }
    }, /*#__PURE__*/React.createElement(TouchableHighlight, {
      underlayColor: this.props.underlayColor,
      onPress: this.open,
      onLongPress: this.props.onLongPress
    }, this.props.children)), this.props.navigator ? false : /*#__PURE__*/React.createElement(LightboxOverlay, this.getOverlayProps()));
  }

}

_defineProperty(Lightbox, "defaultProps", {
  swipeToDismiss: true,
  onOpen: () => {},
  didOpen: () => {},
  willClose: () => {},
  onClose: () => {},
  onLongPress: () => {}
});

export default Lightbox;